/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toolbar-share[_ngcontent-%COMP%]{position:relative;display:inline-block}.toolbar-share-button[_ngcontent-%COMP%]{position:relative;height:60px;line-height:100%;padding:0 25px 0 55px;border:none;overflow:hidden;-webkit-box-sizing:content-box;box-sizing:content-box;vertical-align:middle;text-align:left;font-size:15px;background:#4caf50;color:#fff}.toolbar-share-button__icon[_ngcontent-%COMP%]{position:absolute;top:50%;left:20px;margin-top:-10px;font-size:20px;color:#fff}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/components/toolbar/toolbar-share/toolbar-share.component.styl.shim.ngstyle.js.pre-build-optimizer.js